/* eslint
    arrow-body-style: "warn",
*/

import easyfyAxios from '@shared/easyfy.axios';

namespace Easyfy.Inline.Services {
  export const PostForm = (url: string, data: any) =>
    easyfyAxios.post(url, data);
}

export default Easyfy.Inline.Services;
